import * as angular from 'angular';
import * as moment from 'moment';

import { TagDateValue, SeriesDefinition } from '../../models';
import { ITagsTrendService } from './';

export interface ItrendComparisonService {
    renameComparisonSeries(comparisonSeries: SeriesDefinition<TagDateValue>[], oldName: string, duration: moment.Duration): { newName: string, comparisonSeries: SeriesDefinition<TagDateValue>[] };
    readComparisonData(guid: string, comparisonRange: { beginDate: string, endDate: string }, duration: moment.Duration): angular.IPromise<TagDateValue[]>;
    createComparisonSeries(series: SeriesDefinition<TagDateValue>[], duration: moment.Duration): { newName: string, comparisonSeries: SeriesDefinition<TagDateValue>[] };
}

export class TrendComparisonService implements ItrendComparisonService {
    static serviceId = 'trendComparisonService';

    static $inject = ['tagsTrendService'];
    constructor(private _tagsTrendService: ITagsTrendService) {
    }

    readComparisonData(guid: string,
        comparisonRange: { beginDate: string, endDate: string },
        duration: moment.Duration): angular.IPromise<TagDateValue[]> {
        return this._tagsTrendService.read([{ guid, value: 'average' }], comparisonRange.beginDate,
            comparisonRange.endDate, false, true)
            .then((data) => {
                data = data.values;
                data.forEach((d) => {
                    d.valueType = `comparison${d.guid}${d.valueType}`;
                    const add = moment(d.timeStamp).add(duration);
                    d.timeStamp = add.toISOString();
                    d.date = add.toDate();
                });
                return data;
            });
    }

    createComparisonSeries(series: SeriesDefinition<TagDateValue>[], duration: moment.Duration): { newName: string, comparisonSeries: SeriesDefinition<TagDateValue>[] } {
        const comparisonSeries = [];
        const asMilliseconds = duration
            .asMilliseconds();
        const newName = moment.duration(-asMilliseconds)
            .humanize(true);
        const compareName = this.compareName(newName);
        series
            .forEach(s => {
                const ns = {
                    name: s.name + compareName,
                    identifier: `comparison${s.identifier}`,
                    color: '#999',
                    value: s.value,
                    selector: d => d.valueType,
                    isSymbolVisible: false,
                    isLineVisible: true,
                    hasOwnAxis: false,
                    pane: 0
                };
                comparisonSeries.push(ns);
            });
        return {
            newName,
            comparisonSeries
        };
    }

    renameComparisonSeries(comparisonSeries: SeriesDefinition<TagDateValue>[],
        oldName: string,
        duration: moment.Duration): { newName: string, comparisonSeries: SeriesDefinition<TagDateValue>[] } {
        comparisonSeries = comparisonSeries.map(c => c); //Create a clone of the object for immutability
        const newName = moment.duration(-duration.asMilliseconds())
            .humanize(true);
        comparisonSeries
            .forEach(s => {
                s.name = s.name.replace(oldName, newName);
            });
        return {
            newName,
            comparisonSeries
        };
    }

    private compareName(serieName): string {
        return ` (${serieName})`;
    }
}